import { useTranslation } from 'react-i18next';
import { OptInCheckBoxArray } from './OptInCheckBoxArray';
import { Court, Class } from '../../../../../types/tournament';
import { IScheduleDayConstraints } from '../../../../../types/schedule';
import { getDateString, getTournamentTimezone } from '../schedule.helpers';
import { useAppSelector } from '../../../../../hooks/redux';
import { selectSchedule } from '../../../../../features/schedule/scheduleSelectors';

interface ClassFormatsSetupProps {
  day: IScheduleDayConstraints;
  classes: Class[];
  courts: Court[];
}

export const ClassFormatsSetup = ({ day, classes, courts }: ClassFormatsSetupProps) => {
  const { t } = useTranslation();
  const prefix = 'creativeDetail-';

  const { tournamentInfo } = useAppSelector(selectSchedule);
  const timeZone = getTournamentTimezone(tournamentInfo?.country, tournamentInfo?.timeZone);
  
  return (
    <div className="border rounded p-4 mb-4 bg-white shadow-sm">
      <div className="row mb-3 border-bottom pb-2">
        <h3 className="mb-0">
          {t(prefix + 'scheduleDay')} {day.dayKey + 1}{' '}
          <span className="text-muted fs-5">({getDateString(day.startTime, timeZone)})</span>
        </h3>
      </div>

      <div className="row">
        {/* Only render the Class Opt-Ins here */}
        <div className="col-12">
          <OptInCheckBoxArray name="class" dayKey={day.dayKey} data={classes} courts={courts} />
        </div>
      </div>
    </div>
  );
};
